import React from 'react';

import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import validate from '@vlabs/shared/validators';
import { Control, Divider, Page } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import st from './CreateCardFormComponent.module.sass';

function CreateCardFormComponent({
  onSubmit,
  faceAvatarUrl = undefined,
  eventSampleUrl = undefined,
  lists = [],
  listOptions = [],
}) {
  const { t } = useTranslation();
  const form = useForm({
    defaultValues: {
      external_id: '',
      lists: lists || [],
    },
  });

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Page title={t('lunapoint:add to ID.form.title')}>
        {!!(faceAvatarUrl || eventSampleUrl) && (
          <img
            alt="face sample"
            className={st.FaceImage}
            src={faceAvatarUrl || eventSampleUrl}
          />
        )}
        {!(faceAvatarUrl || eventSampleUrl) && (
          <React.Fragment>
            <Divider small />
            <span className={st.AbsentImage}>{t('изображение отсутствует')}</span>
          </React.Fragment>
        )}
        <Divider small />
        <Control.Input
          autoFocus
          id="external_id"
          label={t('lunapoint:add to ID.form.external_id.label')}
          {...form.register('external_id', {
            required: validate.required(),
            maxLength: validate.maxLength(36),
          })}
          errors={form.formState.errors}
        />
        <Divider small />
        <Control.Select
          control={form.control}
          id="lists"
          isClearable
          isMulti
          label={t('lunapoint:add to ID.form.lists.label')}
          name="lists"
          options={listOptions}
        />
        <Divider />
        <Control.Button
          data-testid="submitCardButton"
          fullWidth
          type="submit"
        >
          {t('lunapoint:add to ID.form.submit.label')}
        </Control.Button>
      </Page>
    </form>
  );
}

CreateCardFormComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  faceAvatarUrl: PropTypes.string,
  eventSampleUrl: PropTypes.string,
  lists: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  listOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};
export const CreateCardForm = connect((state) => ({
  listOptions: selectListOptions(state),
}))(CreateCardFormComponent);
